import { Reveal } from "./Reveal";
import { ImageReveal } from "./ImageReveal";
import { PHOTOS } from "../images";

const STATS = [
  { value: "02", label: "Private villas" },
  { value: "06", label: "Bedrooms in each" },
  { value: "12+2", label: "Guests per villa" },
];

export const Intro = () => (
  <section id="intro" data-testid="intro-section" className="bg-brand-ivory py-20 lg:py-36">
    <div className="mx-auto grid max-w-7xl items-center gap-12 px-6 sm:px-8 lg:grid-cols-2 lg:gap-20">
      <Reveal>
        <p className="mb-5 text-[11px] font-semibold uppercase tracking-[0.28em] text-brand-moss">The stay</p>
        <h2 className="font-serif text-4xl font-light leading-[1.1] tracking-tight text-brand-licorice sm:text-5xl lg:text-6xl">
          A stay designed for <span className="italic text-brand-brunswick">togetherness.</span>
        </h2>
        <p className="mt-7 max-w-lg text-[15px] leading-relaxed text-brand-licorice/70 sm:text-lg">
          Dune Villas are Area 83&rsquo;s most premium stay, built for big groups, bigger celebrations and all-out
          relaxation.
        </p>
        <p className="mt-4 max-w-lg text-[15px] leading-relaxed text-brand-licorice/70 sm:text-lg">
          A short drive from the city, a world away in feel. Your whole group under one roof, with a swimming pool
          and breakfast and dinner taken care of.
        </p>
        <div className="mt-10 flex gap-10 border-t border-brand-champagne pt-8 sm:gap-16">
          {STATS.map((s) => (
            <div key={s.label} data-testid={`intro-stat-${s.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
              <p className="font-serif text-4xl font-light text-brand-brunswick sm:text-5xl">{s.value}</p>
              <p className="mt-2 text-[11px] font-medium uppercase tracking-[0.18em] text-brand-licorice/60">{s.label}</p>
            </div>
          ))}
        </div>
      </Reveal>
      <ImageReveal
        src={PHOTOS.intro}
        alt="The living and dining space inside a Dune Villa"
        label="The living space"
        tone="sepia"
        testId="intro-image"
        className="aspect-[5/4]"
      />
    </div>
  </section>
);
